import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import nameSort from 'scaleflow/utils/nameSort';
import { cached } from '@glimmer/tracking';

export default class InitiativesUpdateWizardLinkMetricsComponent extends Component {
  @service initiativeSlideover;
  @service store;

  @tracked metricSearch = '';
  @tracked selectedMetrics = [];
  @tracked measurementsAreVisible = true;
  @tracked measurements = new Array(this.args.initiative.metrics.length);

  @action
  next() {
    if (!this.args?.next)
      assert('Pass a callback function to the "next" param');
    else this.args?.next();
  }

  @action
  back() {
    if (!this.args?.back)
      assert('Pass a callback function to the "back" param');
    else this.args?.back();
  }

  @action
  closePopovers() {
    this.initiativeSlideover.closeWizard();
    this.initiativeSlideover.close();
  }

  @action
  async saveMeasurements() {
    const promises = [];
    for (let i = 0; i < this.measurements.length; i++) {
      if (this.measurements[i] === undefined) continue;
      const metric = this.orderedMetrics[i].content;
      const measurement = this.store.createRecord('measurement', {
        value: this.measurements[i],
        metric,
        decimals: metric.decimals ?? 2,
      });
      promises.push(measurement.save());
    }
    await Promise.all(promises);
    this.next();
  }

  @cached
  get orderedMetrics() {
    return this.args.initiative.metrics.toSorted((a, b) =>
      nameSort(a.get('title'), b.get('title')),
    );
  }

  @action
  setMeasurementAtIndex(index, e) {
    const measurements = [...this.measurements];
    measurements[index] = e.target.value;
    this.measurements = measurements;
  }
}
